module.exports = __webpack_public_path__ + "static/media/fruit-orange-1.b9fc74ff.png";